import { Draft, produce, WritableDraft } from "immer"

import { BasicInfoFieldsNames } from '../../formDefinitions/BasicInfo/BasicInfoFields'
import { ExtendedInfoFieldsNames } from '../../formDefinitions/ExtendedInfo/ExtendedInfoFields'
import { TAllAdditionalFieldsNames, FormNames, AdditionalFormNames } from '../../models/form/IFormDefinition'
import { 
  FormActions, 
  CHANGE_INCOME_INFO_FIELDS,
  SET_SINGLE_FIELD_VALUE, 
  TOGGLE_ADDITIONAL_FROM, 
  TOGGLE_FIELD_ON_BOOLEAN_CHANGE, 
  ToggleFieldOnBooleanChangeActionType, 
  CLEAR_FIELD_VALIDATION_ERROR,
  SET_SINGLE_FIELD_VALIDATION_ERROR,
  CHANGE_ADDITIONAL_INCOME_INFO_FIELDS
} from '../actions/form-actions'
import { AddressInfoFieldsNames } from '../../formDefinitions/AddressInfoForm/AddressInfoFields'
import { IncomeAdditionalFieldsNames, IncomeBasicFieldsNames } from '../../formDefinitions/IncomeInfoForm/IncomeInfoFields'
import { AdditionalIncomeAdditionalFieldsNames,  AdditionalIncomeBasicFieldsNames } from '../../formDefinitions/IncomeInfoForm/AdditionalIncomeFields'
import { AllFormsState, IFieldsDataState, IFieldsDataStateFieldValue, IFieldsDataStateValue, IFormState } from '../types'




//TODO PRZENIEŚĆ, PRZEJRZEĆ
// ==================================================== GLOBALNE INTERFACE'Y ====================================================




export const formInitialState: AllFormsState = {
   [FormNames.BasicInfoForm]: {
      fieldsData: {
         [BasicInfoFieldsNames.FirstName]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [BasicInfoFieldsNames.Surname]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [BasicInfoFieldsNames.Pesel]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [BasicInfoFieldsNames.PhoneNumber]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [BasicInfoFieldsNames.Email]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [BasicInfoFieldsNames.ConfirmEmail]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
      },
      formConfig: null,
   },
   [FormNames.ExtendedInfoForm]: {
      fieldsData: {
         [ExtendedInfoFieldsNames.PersonalId]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [ExtendedInfoFieldsNames.PersonalIdRelease]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [ExtendedInfoFieldsNames.Education]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [ExtendedInfoFieldsNames.MaritalStatus]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
      },
      formConfig: null,
   },
   [FormNames.AddressInfoForm]: {
      fieldsData: {
         [AddressInfoFieldsNames.City]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [AddressInfoFieldsNames.Street]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [AddressInfoFieldsNames.PostalCode]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [AddressInfoFieldsNames.HouseNumber]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [AddressInfoFieldsNames.ApartamentNumber]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
      },
      formConfig: null,
   },
   [FormNames.IncomeInfoForm]: {
      fieldsData: {
         [IncomeBasicFieldsNames.MainIncomeType]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [IncomeBasicFieldsNames.CostOfLiving]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
         [IncomeBasicFieldsNames.SocialBenefitsNumber]: {
            value: '',
            fieldState: undefined,
            validationError: undefined,
         },
      },
      formConfig: null,
   },

   globalFormConfig: {
      currentOpenedAdditionalForms: [] 
   }
}

export const formReducer = (state: AllFormsState = formInitialState, action: FormActions) => 
   produce(state, (draft: Draft<AllFormsState>) => {

      switch (action.type) {
         case SET_SINGLE_FIELD_VALUE: {
            const { formName, fieldName, newFieldValue, newFieldState } = action.payload;

            if (formName in draft) {
               const form = draft[formName]
               if (form && fieldName in form.fieldsData) {
                  const form = draft[formName] as IFormState<any>

                  if (fieldName in form.fieldsData) {
                     form.fieldsData[fieldName].fieldState = newFieldState 
                     form.fieldsData[fieldName].value = newFieldValue 
                  }
               }
            }
            break;
          }
          case CHANGE_INCOME_INFO_FIELDS: {

               // Extract preserved fields and ensure a new object reference
            const preservedFields = {
               [IncomeBasicFieldsNames.MainIncomeType]: state[FormNames.IncomeInfoForm].fieldsData[IncomeBasicFieldsNames.MainIncomeType],
               [IncomeBasicFieldsNames.CostOfLiving]: state[FormNames.IncomeInfoForm].fieldsData[IncomeBasicFieldsNames.CostOfLiving],
               [IncomeBasicFieldsNames.SocialBenefitsNumber]: state[FormNames.IncomeInfoForm].fieldsData[IncomeBasicFieldsNames.SocialBenefitsNumber],
            }

            // Create a new fieldsData object
            const updatedFieldsData = {
                  ...preservedFields,
                  ...Object.fromEntries(
                     action.payload.map((field: keyof typeof IncomeAdditionalFieldsNames) => [
                        field,
                        {
                              value: '',
                              validationError: '',
                              fieldState: undefined,
                        },
                     ])
                  ),
            };

            // Update the state with a new object reference
            draft[FormNames.IncomeInfoForm] = {
               ...state[FormNames.IncomeInfoForm],
               fieldsData: updatedFieldsData,
               formConfig: {
                  ...state[FormNames.IncomeInfoForm].formConfig,
                  currentIncomeInfoFields: [...action.payload],
               },
            }

            break;
         }
         case CHANGE_ADDITIONAL_INCOME_INFO_FIELDS: {
            // 1. Pola bazowe, które nie zostają przy zmianie dochodu na inny. Przepisujemy ich aktualny stan
            const preservedFields = {
               [AdditionalIncomeBasicFieldsNames.AdditionalIncomeType]: {
                  value: '',
                  validationError: '',
                  fieldState: undefined,
               }
            }
      
            // 2. Tworzymy obiekt z nowymi polami i przypisujemy do niego od razu bazowe pola
            const updatedFieldsData: WritableDraft<IFieldsDataState<typeof AdditionalIncomeBasicFieldsNames> & Partial<IFieldsDataState<typeof AdditionalIncomeAdditionalFieldsNames>>> = { ...preservedFields }


            // 3. Dodajemy nowe pola według danych z pola `fields` z kontrolki z głównym źródłem dochodu.
            for (const field of action.payload) {
               if (field in AdditionalIncomeAdditionalFieldsNames) {
                  const additionalField = field as keyof typeof AdditionalIncomeAdditionalFieldsNames
                  
                  updatedFieldsData[additionalField] = {
                     value: '',
                     validationError: '',
                     fieldState: undefined,
                  } as IFieldsDataStateValue
               }
            }
                  
            // 4. Zamieniamy aktualny stan, na nowy bazując na wcześniej przygotowanym obiekcie.
            draft[AdditionalFormNames.AdditionalIncomeForm] = {
               ...draft[AdditionalFormNames.AdditionalIncomeForm],
               fieldsData: updatedFieldsData,
               formConfig: {
                     ...draft[AdditionalFormNames.AdditionalIncomeForm]?.formConfig,
                     currentIncomeInfoFields: [...action.payload],
               },
            }
               
            break;
         }
         
         case TOGGLE_FIELD_ON_BOOLEAN_CHANGE: {
            const { formName, associatedFieldName, actionType } = action.payload
            let updatedFieldsData: Record<any, any> = {}
            
            if(formName === FormNames.IncomeInfoForm) {
               const previousFieldsData = state[FormNames.IncomeInfoForm].fieldsData
               updatedFieldsData  = { ...previousFieldsData } as WritableDraft<IFieldsDataState<typeof IncomeBasicFieldsNames> & Partial<IFieldsDataState<typeof IncomeAdditionalFieldsNames>>>
                           
               if(actionType === ToggleFieldOnBooleanChangeActionType.ADD_FIELD) {
                  updatedFieldsData[associatedFieldName as keyof typeof IncomeAdditionalFieldsNames] = {
                     value: '',
                     validationError: '',
                     fieldState: undefined,
                  } as IFieldsDataStateValue
               }
               else if (actionType === ToggleFieldOnBooleanChangeActionType.DELETE_FIELD) {
                  delete updatedFieldsData[associatedFieldName as keyof typeof IncomeAdditionalFieldsNames]
               }

               const newAdditionalIncomeInfoFieldNames = Object.keys(updatedFieldsData).filter((fieldName) => Object.keys(IncomeAdditionalFieldsNames).includes(fieldName)) 
               
               draft[FormNames.IncomeInfoForm] = {
                  ...draft[FormNames.IncomeInfoForm],
                  fieldsData: updatedFieldsData as any,
                  formConfig: {
                        ...draft[FormNames.IncomeInfoForm].formConfig,
                        currentIncomeInfoFields: newAdditionalIncomeInfoFieldNames as IncomeAdditionalFieldsNames[],
                  },
               }
            }
            else if(formName === AdditionalFormNames.AdditionalIncomeForm && state[AdditionalFormNames.AdditionalIncomeForm] !== undefined) {
               const previousFieldsData = state[AdditionalFormNames.AdditionalIncomeForm].fieldsData
               updatedFieldsData = { ...previousFieldsData } as WritableDraft<IFieldsDataState<typeof AdditionalIncomeBasicFieldsNames> & Partial<IFieldsDataState<typeof AdditionalIncomeAdditionalFieldsNames>>>

               if(actionType === ToggleFieldOnBooleanChangeActionType.ADD_FIELD) {
                  updatedFieldsData[associatedFieldName as keyof typeof AdditionalIncomeAdditionalFieldsNames] = {
                     value: '',
                     validationError: '',
                     fieldState: undefined,
                  } as IFieldsDataStateValue
               }
               else if (actionType === ToggleFieldOnBooleanChangeActionType.DELETE_FIELD) {
                  delete updatedFieldsData[associatedFieldName as keyof typeof AdditionalIncomeAdditionalFieldsNames]
               }
               
               const newAdditionalIncomeInfoFieldNames = Object.keys(updatedFieldsData).filter((fieldName) => Object.keys(AdditionalIncomeAdditionalFieldsNames).includes(fieldName)) 
     
               draft[AdditionalFormNames.AdditionalIncomeForm] = {
                  ...draft[AdditionalFormNames.AdditionalIncomeForm],
                  fieldsData: updatedFieldsData as any,
                  formConfig: {
                        ...draft[AdditionalFormNames.AdditionalIncomeForm]?.formConfig,
                        currentIncomeInfoFields: newAdditionalIncomeInfoFieldNames as AdditionalIncomeAdditionalFieldsNames[],
                  },
               }
            }

            break;
         }

         case TOGGLE_ADDITIONAL_FROM: { // Upewniamy się że mamy doczynienia z dodatkowym formularzem

            const { formName, isAdditionalFormOpen, additionalFieldsNamesToAdd } = action.payload

            if (isAdditionalFormOpen && formName in AdditionalFormNames) {
               const fieldsData = additionalFieldsNamesToAdd.reduce((acc, fieldName) => {
                   acc[fieldName] = {
                       value: '',
                       fieldState: undefined,
                       validationError: undefined,
                   }
                   return acc
               }, {} as Record<TAllAdditionalFieldsNames, IFieldsDataStateValue>)
                     
               draft[formName] = {
                   fieldsData: fieldsData,
                   formConfig: null
               }
       
               draft.globalFormConfig.currentOpenedAdditionalForms = [
                   ...state.globalFormConfig.currentOpenedAdditionalForms, formName
               ]
           } 
           else {
               delete draft[formName]; // Removing form state when it's not needed

               draft.globalFormConfig.currentOpenedAdditionalForms = state.globalFormConfig.currentOpenedAdditionalForms.filter(formNameInCurrentArray => formNameInCurrentArray !== formName)
           }

           break;
         }
         case CLEAR_FIELD_VALIDATION_ERROR: {
            const { formName, fieldName } = action.payload;

            if (formName in draft) {
               const form = draft[formName]
               if (form && fieldName in form.fieldsData) {
                  const form = draft[formName] as IFormState<any>

                  if (fieldName in form.fieldsData) {
                     form.fieldsData[fieldName].validationError = null
                  }
               }
            }

            break;
         }
         case SET_SINGLE_FIELD_VALIDATION_ERROR: {
            const { formName, fieldName, newValidationError } = action.payload;

            if (formName in draft) {
               const form = draft[formName]
               if (form && fieldName in form.fieldsData) {
                  const form = draft[formName] as IFormState<any>

                  if (fieldName in form.fieldsData) {
                     form.fieldsData[fieldName].validationError = newValidationError
                  }
               }
            }

            break;
         }   
         default: {
            return state
         }
      }
   }) 